import React, { useState } from 'react'

import FilterIcon from 'presentation/assets/icons/funnel.svg'
import StatusIndicator from '../StatusIndicator'

import * as S from './styles'
import { DoctorRegisterStatus } from 'common/enum/doctor-register-status'

type StatusFilterProps = {
  onChange(value: string): void
}

export default function StatusFilter({ onChange }: StatusFilterProps) {
  const [selectedFilter, setSelectedFilter] = useState<DoctorRegisterStatus>()

  const options = [
    {
      label: 'Cadastro não revisado',
      value: DoctorRegisterStatus.UNREVIEWED_REGISTER,
      children: (
        <S.FilterSelected>
          <StatusIndicator status={DoctorRegisterStatus.UNREVIEWED_REGISTER} />
          <label>Cadastro não revisado</label>
        </S.FilterSelected>
      )
    },
    {
      label: 'Pendente',
      value: DoctorRegisterStatus.PENDENT,
      children: (
        <S.FilterSelected>
          <StatusIndicator status={DoctorRegisterStatus.PENDENT} />
          <label>Pendente</label>
        </S.FilterSelected>
      )
    },
    {
      label: 'Revisão gerada pela Diretoria',
      value: DoctorRegisterStatus.REVIEWED_BY_DIRECTOR,
      children: (
        <S.FilterSelected>
          <StatusIndicator status={DoctorRegisterStatus.REVIEWED_BY_DIRECTOR} />
          <label>Revisão gerada pela Diretoria</label>
        </S.FilterSelected>
      )
    },
    {
      label: 'Aprovada pelo diretor mas com pendência',
      value: DoctorRegisterStatus.APPROVED_BY_DIRECTOR_WITH_PENDENCIES,
      children: (
        <S.FilterSelected>
          <StatusIndicator
            status={DoctorRegisterStatus.APPROVED_BY_DIRECTOR_WITH_PENDENCIES}
          />
          <label>Aprovada pelo diretor mas com pendência</label>
        </S.FilterSelected>
      )
    },
    {
      label: 'Pendência respondida pelo profissional',
      value: DoctorRegisterStatus.PENDENCY_ANSWERED,
      children: (
        <S.FilterSelected>
          <StatusIndicator status={DoctorRegisterStatus.PENDENCY_ANSWERED} />
          <label>Pendência respondida pelo profissional</label>
        </S.FilterSelected>
      )
    },
    {
      label: 'Cadastro enviado para o Diretor',
      value: DoctorRegisterStatus.REGISTER_SEND_TO_DIRECTOR,
      children: (
        <S.FilterSelected>
          <StatusIndicator
            status={DoctorRegisterStatus.REGISTER_SEND_TO_DIRECTOR}
          />
          <label>Cadastro enviado para o Diretor</label>
        </S.FilterSelected>
      )
    },
    {
      label: 'Cadastro concluído',
      value: DoctorRegisterStatus.REGISTER_CONCLUDED,
      children: (
        <S.FilterSelected>
          <StatusIndicator status={DoctorRegisterStatus.REGISTER_CONCLUDED} />
          <label>Cadastro concluído</label>
        </S.FilterSelected>
      )
    },
    {
      label: 'Cadastro reprovado pela diretoria',
      value: DoctorRegisterStatus.REGISTER_REPROVED_BY_DIRECTOR,
      children: (
        <S.FilterSelected>
          <StatusIndicator
            status={DoctorRegisterStatus.REGISTER_REPROVED_BY_DIRECTOR}
          />
          <label>Cadastro reprovado pela diretoria</label>
        </S.FilterSelected>
      )
    }
  ]

  const handleChangeFilter = (status: DoctorRegisterStatus) => {
    setSelectedFilter(status)
    onChange(status)
  }

  const getLabelByStatus = (status: DoctorRegisterStatus) => {
    const item = options.find((item) => item.value === status)
    return item ? item.label : ''
  }

  return (
    <S.Wrapper>
      <S.StyledSelect
        variant="outlined"
        value={selectedFilter}
        displayEmpty
        renderValue={(value) => {
          if (!selectedFilter) {
            return (
              <S.NoFilterSelected>
                <img src={FilterIcon} alt="Ícone de filtro" />
                <label>Filtrar por status: </label>
              </S.NoFilterSelected>
            )
          }
          return (
            <S.FilterSelected>
              <StatusIndicator status={value as DoctorRegisterStatus} />
              <label>{getLabelByStatus(selectedFilter)}</label>
            </S.FilterSelected>
          )
        }}
        onChange={(e) => {
          handleChangeFilter(e.target.value as DoctorRegisterStatus)
        }}
      >
        {options.map((item) => (
          <S.StyledMenuItem key={item.value} value={item.value}>
            {item.children}
          </S.StyledMenuItem>
        ))}
      </S.StyledSelect>
    </S.Wrapper>
  )
}
